export const usaHeatmapGeoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

export const crowdedStateLabels = {
  Connecticut: { dx: 34, dy: 24, anchor: "start" },
  Delaware: { dx: 36, dy: 4, anchor: "start" },
  Maryland: { dx: 38, dy: 18, anchor: "start" },
  Massachusetts: { dx: 42, dy: -10, anchor: "start" },
  "New Hampshire": { dx: 28, dy: -24, anchor: "start" },
  "New Jersey": { dx: 34, dy: 10, anchor: "start" },
  "Rhode Island": { dx: 46, dy: 10, anchor: "start" },
  Vermont: { dx: -18, dy: -24, anchor: "end" },
};

export const mapLabelStyle = {
  fill: "#111827",
  fontFamily: "Arial, sans-serif",
  fontSize: "9px",
  fontWeight: 700,
  paintOrder: "stroke",
  stroke: "rgba(255, 255, 255, 0.9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
};

export const mapLabelConnectorProps = {
  stroke: "rgba(17, 24, 39, 0.45)",
  strokeWidth: 0.75,
  strokeLinecap: "round",
};
